import { createContext } from "react";
import { WaitingConversationInfo } from "../../models/reports.queues";
import { WorkItemPickErrorState } from "./WaitingConversationsContext.usePersistTaskStates";

export interface WaitingConversationsContextValue {
  takeableWaitingConversations: WaitingConversationInfo[];
  allWaitingConversations: WaitingConversationInfo[];
  setConversationErrorState(conversationId: WaitingConversationInfo["conversationId"], errorState: WorkItemPickErrorState): void;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const WaitingConversationsContext = createContext<WaitingConversationsContextValue>(undefined!);
